(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);

  // Default to best-selling sort when no sort is specified
  if (!url.searchParams.has('sort_by')) {
    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.toString());
  }

  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  /* Strip colour suffix from product title (e.g. "Jacket - Ink Navy" → "Jacket") */
  document.querySelectorAll('.product-details h1').forEach(function(h1) {
    var parts = h1.textContent.split(' - ');
    if (parts.length > 1) {
      h1.textContent = parts.slice(0, -1).join(' - ');
    }
  });

  /* Move size guide table into the Size & Fitting accordion */
  var sizeGuide = document.getElementById('size-guide-inject');
  if (sizeGuide) {
    var accordions = document.querySelectorAll('.product-details .accordion .details__header');
    accordions.forEach(function(header) {
      if (header.textContent.trim().toUpperCase().indexOf('SIZE') === 0) {
        var content = header.closest('.details').querySelector('.details-content');
        if (content) {
          content.innerHTML = '';
          content.appendChild(sizeGuide);
          sizeGuide.style.display = '';
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
